export default "\r\n<div style=\"min-height: 436px;\">\r\n    <loading></loading>\r\n    <router-outlet></router-outlet>\r\n</div>";